import { T } from "../localization";
import React from "react";

interface TermsModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onAgree: () => void;
}

const TermsModal: React.FC<TermsModalProps> = ({ open, setOpen, onAgree }) => {
  return (
    <div
      className={`fixed inset-0 px-2 z-50 overflow-hidden flex items-center justify-center transition-opacity duration-300 ${
        open
          ? "opacity-100 pointer-events-auto"
          : "opacity-0 pointer-events-none"
      }`}
      onClick={() => setOpen(false)}
    >
      <div className="absolute inset-0 bg-gray-500 bg-opacity-75"></div>

      <div
        className={`bg-white rounded-md shadow-xl overflow-hidden max-w-md w-full z-50 transition-all duration-300 transform ${
          open ? "scale-100" : "scale-75"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Modal Header */}
        <div className="!text-white px-4 py-3 bg-red-500 flex justify-between items-center">
          <h2 className="text-lg font-semibold text-white">
            <T text="Before you continue" />
          </h2>
        </div>

        {/* Modal Body */}
        <div className="p-4 text-gray-800 space-y-4 text-sm">
          <p>
            <T text="By continuing, you agree to our" /><T text={" "} />
            <a
              href="/terms"
              target="_blank"
              className="text-blue-600 underline"
            >
              <T text="Terms of Service" />
            </a><T text={" "} />
            <T text="and" /><T text={" "} />
            <a
              href="/privacy"
              target="_blank"
              className="text-blue-600 underline"
            >
              <T text="Privacy Policy" />
            </a>
            .
          </p>
        </div>

        {/* Modal Footer */}
        <div className="flex justify-end gap-4 border-t p-4">
          <button
            onClick={() => setOpen(false)}
            className="px-4 py-2 text-sm rounded-md border border-gray-300 hover:bg-gray-100"
          >
            <T text="Cancel" />
          </button>
          <button
            onClick={() => {
              setOpen(false);
              onAgree();
            }}
            className="px-4 py-2b first-line bg-red-500 hover:bg-red-600 text-white text-sm rounded-md"
          >
            <T text="I Agree" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
